export const count = [];

export const pageSizeOptions = [
	{
		value: 5,
		label: '5',
	},
	{
		value: 10,
		label: '10',
	},
	{
		value: 15,
		label: '15',
	},
	{
		value: 20,
		label: '20',
	},
	{
		value: 50,
		label: '50',
	},
];
